import { IconType } from "../../type/icon_type";
import React from "react";

const NaverPayIcon = (props: IconType) => {
  const { color, width, height, style } = props;

  return (
    <svg
      width={width || "55px"}
      height={height || "20px"}
      viewBox="0 0 55 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g clipPath="url(#clip0_5130_75189)">
        <path
          d="M44.5927 0C50.3395 0 55 4.4781 55 10C55 15.5219 50.3395 20 44.5927 20H10.4073C4.66049 20 0 15.5219 0 10C0 4.4781 4.66049 0 10.4073 0H44.5927Z"
          fill="#00DE5A"
        />
        <path
          d="M10.4242 17.249C6.25056 17.249 2.86719 14.0033 2.86719 9.99952C2.86719 5.99571 6.25056 2.75 10.4242 2.75C14.5979 2.75 17.9813 5.99571 17.9813 9.99952C17.9833 14.0033 14.5998 17.249 10.4242 17.249ZM11.8836 6.37286V10.3595L8.96286 6.37286H6.64569V13.6224H8.96683V9.63573L11.8876 13.6224H14.2047V6.37286H11.8836Z"
          fill="black"
        />
        <path
          d="M47.8335 5.39399L45.5938 10.3197L43.1198 5.39399H40.8602L44.605 12.3845L43.0999 15.6226H45.2344L49.966 5.39399H47.8335ZM37.7091 13.2321H39.7324V5.39208H37.7091V6.03589C37.0142 5.49875 36.2279 5.21875 35.2748 5.21875C32.9736 5.21875 31.1707 7.03208 31.1707 9.31018C31.1707 11.5883 32.9736 13.4016 35.2748 13.4016C36.2279 13.4016 37.0142 13.1216 37.7091 12.5845V13.2321ZM35.5687 11.8149C34.2145 11.8149 33.196 10.7407 33.196 9.31399C33.196 7.88732 34.2165 6.81304 35.5687 6.81304C36.9209 6.81304 37.9414 7.88732 37.9414 9.31399C37.9434 10.7387 36.9229 11.8149 35.5687 11.8149ZM23.6534 12.6264C24.3344 13.1387 25.0969 13.4054 26.0162 13.4054C28.3174 13.4054 30.1203 11.5921 30.1203 9.31399C30.1203 7.03589 28.3174 5.22256 26.0162 5.22256C25.0631 5.22256 24.2768 5.50256 23.5819 6.0397V5.39589H21.5586V15.6245H23.6514V12.6264H23.6534ZM23.3496 9.31399C23.3496 7.88732 24.3701 6.81304 25.7223 6.81304C27.0745 6.81304 28.0951 7.88732 28.0951 9.31399C28.0951 10.7407 27.0745 11.8149 25.7223 11.8149C24.3701 11.8149 23.3496 10.7387 23.3496 9.31399Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_5130_75189">
          <rect width="55" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NaverPayIcon;
